import type { NetExposureMarket } from './fixture'

/** Premium BM = Artemis PB feed (`key: PB`) or Lab name heuristics. */
export function isPremiumBmMarket(
  market: Pick<NetExposureMarket, 'marketName' | 'key' | 'bookmakerFlag'> & {
    productType?: string
  },
): boolean {
  const product = (market.productType || '').toLowerCase()
  if (product === 'artemis') return true
  if (market.key === 'PB') return true
  const name = market.marketName.toLowerCase()
  return name.includes('premium') || name.includes('artemis')
}
